/**
 * Budgets Services Module
 * Exports all budget management services and the factory function.
 */
export { BudgetService } from './BudgetService';
export { BudgetAllocationService } from './BudgetAllocationService';
export { BudgetItemService } from './BudgetItemService';
export { BudgetCategoryService } from './BudgetCategoryService';
export { BudgetReleaseService } from './BudgetReleaseService';
export { BudgetChangeRequestService } from './BudgetChangeRequestService';
export { BudgetApprovalService } from './BudgetApprovalService';
export { BudgetCheckService } from './BudgetCheckService';
export { BudgetTransactionService } from './BudgetTransactionService';
export { BudgetAlertService } from './BudgetAlertService';
export { BudgetAlertThresholdService } from './BudgetAlertThresholdService';
export { BudgetDashboardService } from './BudgetDashboardService';
export { BudgetSettingService } from './BudgetSettingService';
export { BudgetTypeService } from './BudgetTypeService';
export { BudgetStatusService } from './BudgetStatusService';
export { BudgetFundingSourceTypeService } from './BudgetFundingSourceTypeService';
export { BudgetTransactionTypeService } from './BudgetTransactionTypeService';
export { BudgetTransactionSourceService } from './BudgetTransactionSourceService';
export { BudgetApprovalStatusService } from './BudgetApprovalStatusService';
export { BudgetHealthStatusService } from './BudgetHealthStatusService';
export { BudgetAmountInputTypeService } from './BudgetAmountInputTypeService';
export { BudgetChangeRequestTypeService } from './BudgetChangeRequestTypeService';
export { BudgetReleaseValueTypeService } from './BudgetReleaseValueTypeService';
// v3
export { BudgetForecastService } from './BudgetForecastService';
export { BudgetAnomalyService } from './BudgetAnomalyService';
export { BudgetReportService } from './BudgetReportService';
import { BudgetService } from './BudgetService';
import { BudgetAllocationService } from './BudgetAllocationService';
import { BudgetItemService } from './BudgetItemService';
import { BudgetCategoryService } from './BudgetCategoryService';
import { BudgetReleaseService } from './BudgetReleaseService';
import { BudgetChangeRequestService } from './BudgetChangeRequestService';
import { BudgetApprovalService } from './BudgetApprovalService';
import { BudgetCheckService } from './BudgetCheckService';
import { BudgetTransactionService } from './BudgetTransactionService';
import { BudgetAlertService } from './BudgetAlertService';
import { BudgetAlertThresholdService } from './BudgetAlertThresholdService';
import { BudgetDashboardService } from './BudgetDashboardService';
import { BudgetSettingService } from './BudgetSettingService';
import { BudgetTypeService } from './BudgetTypeService';
import { BudgetStatusService } from './BudgetStatusService';
import { BudgetFundingSourceTypeService } from './BudgetFundingSourceTypeService';
import { BudgetTransactionTypeService } from './BudgetTransactionTypeService';
import { BudgetTransactionSourceService } from './BudgetTransactionSourceService';
import { BudgetApprovalStatusService } from './BudgetApprovalStatusService';
import { BudgetHealthStatusService } from './BudgetHealthStatusService';
import { BudgetAmountInputTypeService } from './BudgetAmountInputTypeService';
import { BudgetChangeRequestTypeService } from './BudgetChangeRequestTypeService';
import { BudgetReleaseValueTypeService } from './BudgetReleaseValueTypeService';
import { BudgetForecastService } from './BudgetForecastService';
import { BudgetAnomalyService } from './BudgetAnomalyService';
import { BudgetReportService } from './BudgetReportService';
/**
 * Create all budget management services with shared configuration.
 */
export function createBudgetsServices(http, config) {
    return {
        budget: new BudgetService(http, config),
        budgetAllocation: new BudgetAllocationService(http, config),
        budgetItem: new BudgetItemService(http, config),
        budgetCategory: new BudgetCategoryService(http, config),
        budgetRelease: new BudgetReleaseService(http, config),
        budgetChangeRequest: new BudgetChangeRequestService(http, config),
        budgetApproval: new BudgetApprovalService(http, config),
        budgetCheck: new BudgetCheckService(http, config),
        budgetTransaction: new BudgetTransactionService(http, config),
        budgetAlert: new BudgetAlertService(http, config),
        budgetAlertThreshold: new BudgetAlertThresholdService(http, config),
        budgetDashboard: new BudgetDashboardService(http, config),
        budgetSetting: new BudgetSettingService(http, config),
        budgetType: new BudgetTypeService(http, config),
        budgetStatus: new BudgetStatusService(http, config),
        budgetFundingSourceType: new BudgetFundingSourceTypeService(http, config),
        budgetTransactionType: new BudgetTransactionTypeService(http, config),
        budgetTransactionSource: new BudgetTransactionSourceService(http, config),
        budgetApprovalStatus: new BudgetApprovalStatusService(http, config),
        budgetHealthStatus: new BudgetHealthStatusService(http, config),
        budgetAmountInputType: new BudgetAmountInputTypeService(http, config),
        budgetChangeRequestType: new BudgetChangeRequestTypeService(http, config),
        budgetReleaseValueType: new BudgetReleaseValueTypeService(http, config),
        budgetForecast: new BudgetForecastService(http, config),
        budgetAnomaly: new BudgetAnomalyService(http, config),
        budgetReport: new BudgetReportService(http, config),
    };
}
//# sourceMappingURL=index.js.map